import { createPondApi } from 'core/api/apiFactory'
import { useParams } from 'react-router-dom'

const usePondApi = () => {
  const { farmId, pondId } = useParams<{ farmId: string; pondId: string }>()
  if (!farmId || !pondId) throw new Error('Farm ID or Pond ID is missing')

  return createPondApi({ farmId, pondId })
}

export default usePondApi
